<a class="nav-link dropdown-toggle" (click)="(false)" href data-toggle="dropdown" dropdownToggle>
  <i class="material-icons md-18 md-nav-align">language</i>{{ dropDownLabel }}
  <span class="caret"></span>
</a>
<ul *dropdownMenu class="dropdown-menu animation-on-widget-open-fadeIn" role="menu">
  <li role="menuitem" *ngFor="let curentLang of languageList">
    <a class="dropdown-item" href="#" (click)="changeLanguage(curentLang)">{{
      curentLang.label
    }}</a>
  </li>
</ul>
